import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import AsyncApp from './components/AsyncApp';
import LocateByCollection from './components/Locate/LocateByCollection';
import LocateByToken from './components/Locate/LocateByToken';
import SelectRecord from './components/Record/SelectRecord';
import EditRecord from './components/Record/EditRecord';
import CreateRecord from './components/Record/CreateRecord';
import RecordSaved from './components/Record/RecordSaved';
import Unauthorized from './components/Common/Unauthorized';
import ErrorView from './components/Common/Error';
import Home from './components/Home/Home';
import Tos from './components/Home/tos';
import Privacy from './components/Home/privacy';

import LogIn from './components/Manage/LogIn';
import ControlPanel from './components/Manage/ControlPanel';
import AuthRequests from "./components/Manage/AuthRequests";

import SearchForm501F from './components/501F/Search';
import SearchFormD5 from './components/D5/Search';

const AuthenticatedRoute = ({component: Component, authed, ...rest}) => {
    return (
        <Route
            {...rest}
            render={(props) => authed === true
                    ? <Component {...props} />
                    : <Redirect to={{pathname:'/app/manage/login', state: {from: props.location}}} />}
        />
    )
}

const AppRoutes = (props) => {
    let state = props.getState();
    let authed = state.user.authToken ? true : false;

    return (<AsyncApp>
        <Switch>
            <Route path='/app/locate/by-collection/:collectionId' component={LocateByCollection} exact/>
            <Route path='/app/locate/by-token/:collectionId/:authToken/:secret?' component={LocateByToken} exact/>
            <Route path='/app/record/find/:collectionId' component={SelectRecord} exact/>
            <Route path='/app/record/edit/:recordId' component={EditRecord} exact/>
            <Route path='/app/record/create/:collectionId' component={CreateRecord} exact/>
            <Route path='/app/record/saved/:collectionId' component={RecordSaved} exact/>
            <Route path='/app/common/unauthorized' component={Unauthorized} exact/>
            <Route path='/app/common/error' component={ErrorView} exact/>


            <Route path='/app/manage/login' component={LogIn} exact/>
            <AuthenticatedRoute path='/app/manage/control-panel' authed={authed} component={ControlPanel} exact/>
            <AuthenticatedRoute path='/app/manage/auth-requests' authed={authed} component={AuthRequests} exact/>

            <AuthenticatedRoute path='/app/501f/search' authed={authed} component={SearchForm501F} exact/>
            <AuthenticatedRoute path='/app/d5/search' authed={authed} component={SearchFormD5} exact/>

            <Route path='/app/tos' component={Tos} exact/>
            <Route path='/app/privacy' component={Privacy} exact/>
            <Route path='/' component={Home} exact/>
        </Switch>
    </AsyncApp>);
}

export default AppRoutes;